import(/* webpackMode: "eager" */ "/codebuild/output/src1258741314/src/app/home/page.tsx");
